import gql from 'graphql-tag.macro';

const getUnreadNotificationsCountQuery = gql`
  query getUnreadNotificationsCount {
    unreadNotificationsCount
  }
`;

const reducer = (payload) => payload.unreadNotificationsCount;

export const getUnreadNotificationsCount = {
  query: getUnreadNotificationsCountQuery,
  reducer,
};
